/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as api from "../../../api";
export { api };
export var GMVRank = {
  TOP20PCT: 1,
  TOP40PCT: 2,
  TOP60PCT: 3,
  OTHERS: 4
};
export var ArticleModuleName = {
  AFFILIATE_GUIDE: 1,
  WELCOME_GUIDE: 2
};
export var ScreenshotStatus = {
  Success: 0,
  Processing: 1,
  Fail: 2
};
export var BizType = {
  PartnerLeaderboard: 1
};